<p-confirmDialog key="pass" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu-->
<div class="MainGrid2Col">
	<label>Username:</label>
	<label class="InfoText">{{ UserName }}</label>

	<label>New Password:</label>
	<input [disabled]="LoadingPrefs == true || PasswordUpdating == true" class="form-control" type="password" [(ngModel)]="NewPassword" />

	<label>Confirm Password:</label>
	<input [disabled]="LoadingPrefs == true || PasswordUpdating == true" class="form-control" type="password" [(ngModel)]="ConfirmPassword" />

	<label class="InstructionLabel">{{ PasswordInstructions }}</label>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="LoadingPrefs == true || PasswordUpdating == true" class="btn btn-primary" (click)="onUpdate()">Confirm</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
